import { call, put } from 'redux-saga/effects';
import { requestGetMasterReport, requestGetMasterReportTask, requestGetReportClients, requestGetReportAccounts, requestGetReportUsers, requestGetRetainers, requestGetProjectProfitability, requestGetResourceUtilization, requestGetDailyHours, requestGetMyDailyHours, requestGetReportDepartments, requestGetArAging, requestGetProfitabilityTrend, requestGetHoursPosted } from '../requests/reports';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetMasterReport(action) {
    try {
        const { filters, callback } = action.payload;
        const response = yield call(requestGetMasterReport, filters);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetMasterReportTask(action) {
    try {
        const { taskId, callback } = action.payload;
        const response = yield call(requestGetMasterReportTask, taskId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetReportClients(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetReportClients);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetReportAccounts(action) {
    try {
        const { client, callback } = action.payload;
        const response = yield call(requestGetReportAccounts, client);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetReportUsers(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetReportUsers);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetRetainers(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetRetainers, startDate, endDate);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}   

export function* handleGetProjectProfitability(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetProjectProfitability, startDate, endDate);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetResourceUtilization(action) {
    try {
        const { startDate, endDate, groupByMonth, callback } = action.payload;
        const response = yield call(requestGetResourceUtilization, startDate, endDate, groupByMonth);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetDailyHours(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetDailyHours, startDate, endDate);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetMyDailyHours(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetMyDailyHours, startDate, endDate);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetReportDepartments(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetReportDepartments);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetArAging(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetArAging);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetHoursPosted(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetHoursPosted, startDate, endDate);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetProfitabilityTrend(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetProfitabilityTrend, startDate, endDate);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}